import Vue from "vue"
import _ from "lodash"
import { isCartPage } from "@/utils/utils"
// ;(async function () {
let deviceWidth
let top
let wellcome
// 初始化设置缩放
setHtmlFontSize()
if (window.addEventListener) {
  window.addEventListener("load", function () {
    // header 适配
    top = document.getElementById("top-box-wrapper")
    wellcome = document.getElementById("wellcome-bg-wrapper")
  })
  window.addEventListener("resize", setHtmlFontSize, false)
  window.addEventListener("scroll", _.throttle(handleScroll, 100), false)
}

function throttle(fn, wait) {
  let previous = 0
  return function (...args) {
    const now = +new Date()
    if (now - previous >= wait) {
      fn.apply(this, args)
      previous = now
    }
  }
}
function setHtmlFontSize() {
  // 1360是设计稿的宽度，大于1360宽度为1360，小于1100宽度为1100
  deviceWidth = document.documentElement.clientWidth >= 1360 ? 1360 : document.documentElement.clientWidth
  const scale = parseFloat(deviceWidth / 1360)
  document.documentElement.style.fontSize = scale * 100 + "px"
  document.documentElement.style.setProperty("--zoom-level", scale)
}

function handleScroll() {
  const scrollT = document.documentElement.scrollTop || document.body.scrollTop
  const topbox = document.getElementById("top-wrapper")
  const topContent = document.getElementById("top-content-wrapper")
  const searchWrapper = document.getElementById("search-wrapper")
  // const addressWrapper = document.getElementById("address-wrapper")
  const wellcome = document.getElementById("wellcome-bg-wrapper")
  const logo = document.getElementById("super-logo")
  const searchInputBox = document.getElementById("search-input-box")
  const searchPopContainer = document.getElementById("search-pop-container")
  const search = document.getElementById("Search")
  const productCon = document.getElementById("productCon")
  const productScroll = document.getElementById("productScroll")
  const producContainer = document.getElementById("producContainer")
  const productCarBar = document.getElementById("productCarBar")
  if (producContainer) {
    const rect = producContainer.getBoundingClientRect() // 获取元素相对于视窗的位置信息
    const windowHeight = window.innerHeight // 浏览器窗口高度
    // 判断元素底部是否与窗口底部对齐
    if (rect.bottom - windowHeight < 1) {
      productCarBar.classList.remove("fixed") // 移除class名称
    } else {
      productCarBar.classList.add("fixed")
    }
  }

  if (scrollT > 200) {
    if (productCon) {
      productCon.style.top = "1.37rem"
      productCon.style.height = "calc(100vh - 1.37rem)"
    }
  } else if (scrollT > 60) {
    if (productCon) {
      productCon.style.height = "calc(100vh - 1.86rem)"
    }
  } else {
    if (productCon) {
      productCon.style.top = "1.86rem"
      productCon.style.height = "calc(100vh - 2.46rem)"
      const h = 2.46 - scrollT / 100
      productCon.style.height = "calc(100vh - " + h.toFixed(2) + "rem)"
    }
  }
  if (scrollT > 200) {
    Vue.prototype.$bus && Vue.prototype.$bus.$emit("setShortenHeader", true)
    if (topbox) {
      topbox.style.height = 0
      topbox.style.padding = 0
      topbox.style.overflow = "hidden"
    }
    if (topContent) {
      topContent.style.height = isCartPage() ? "0.84rem" : "1.21rem"
    }
    if (searchWrapper) {
      searchWrapper.style.paddingTop = "0.12rem"
    }
    // if (addressWrapper) {
    //   addressWrapper.style.height = 0
    //   addressWrapper.style.paddingTop = 0
    //   addressWrapper.style.overflow = "hidden"
    // }
    if (wellcome) {
      wellcome.style.height = "0.46rem"
      wellcome.style.top = "0.75rem"
    }
    logo.style.height = "0.44rem"
    logo.style.width = "0.44rem"
    logo.style.bottom = "0"
    searchInputBox.style.width = "6.42rem"
    searchInputBox.style.marginLeft = "0.64rem"
    searchPopContainer.style.width = "6.42rem"
    search.style.maxWidth = "6.35rem"
  } else {
    Vue.prototype.$bus && Vue.prototype.$bus.$emit("setShortenHeader", false)
    if (topbox) {
      topbox.style.height = "unset"
      topbox.style.paddingTop = "0.1rem"
      topbox.style.overflow = "unset"
    }
    if (topContent) {
      topContent.style.height = isCartPage() ? "1.16rem" : "1.39rem"
    }
    if (searchWrapper) {
      searchWrapper.style.paddingTop = "0.1rem"
    }
    // if (addressWrapper) {
    //   addressWrapper.style.height = "unset"
    //   addressWrapper.style.paddingTop = "0.2rem"
    //   addressWrapper.style.overflow = "unset"
    // }
    if (wellcome) {
      wellcome.style.height = "0.58rem"
      wellcome.style.top = "1.12rem"
    }

    logo.style.height = "0.64rem"
    logo.style.width = "0.64rem"
    logo.style.bottom = "0"
    searchInputBox.style.width = "6.22rem"
    searchInputBox.style.marginLeft = "0.84rem"
    searchPopContainer.style.width = "6.22rem"
    search.style.maxWidth = "5.95rem"
  }
}
// })()
